var map = {
	"./D80_8902.jpg": 6229,
	"./D80_8907.jpg": 6268,
	"./D80_8939.jpg": 7063,
	"./D80_8949.jpg": 6750,
	"./D80_8957.jpg": 6751,
	"./D80_8973.jpg": 4649,
	"./D80_9053.jpg": 2665,
	"./Tails20.jpg": 349,
	"./Tails22.jpg": 488,
	"./Tails68.jpg": 318,
	"./Tails98.jpg": 6671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8350;